/**
 * Permission identifiers for the administrative fixed asset module — Issue #364.
 *
 * Mirrors apps/api/src/auth/services/module-catalog.ts so frontend gating
 * cannot diverge from backend RBAC.
 */
import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const ADMIN_ASSETS_PERMISSIONS = {
  READ: 'admin_assets:read',
  WRITE: 'admin_assets:write',
  MANAGE: 'admin_assets:manage',
  FINANCE: 'admin_assets:finance',
} as const;

export function canSeeAdminAssetsMenu(
  permissions: readonly string[],
): boolean {
  return hasAnyPermission(permissions, [ADMIN_ASSETS_PERMISSIONS.READ]);
}
